/* eslint-disable import/no-cycle */
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { persistor } from '../..';
import authApi from '../../../services/authApi';

import Types from './types';
import Actions from './actions';
import User from '../../models/User';

export const KEYCLOAK_LOGIN_CODE_RESPONSE = {
  RESET_PASSWORD: 'RESET_PASSWORD',
};

const FIDELIDADE_SITE_SLUG = 'FIDELIDADE_CARGON';

export function* signIn({ payload }) {
  const { email, password, formRef, history, from, resetPasswordFn } = payload;

  try {
    const response = yield call(authApi.post, '/auth/v2/login', {
      email,
      password,
    });

    const { user: userProperties, token } = response.data.result;
    const userSites = userProperties.sites || [];
    const hasPermission = userSites.some(
      site => site.slug === FIDELIDADE_SITE_SLUG
    );

    if (!userSites.length || !hasPermission) {
      yield put(
        Actions.signInFailure(
          'Você não tem acesso ao portal fidelidade.',
          formRef
        )
      );
      return;
    }

    const reshapeToken = {
      ...token,
      token: token.accessToken,
    };
    const user = new User(userProperties, reshapeToken);

    yield put(Actions.signInSuccess(user, { history, from }));
  } catch (ex) {
    let message = 'Algo deu errado, tente novamente.';

    if (ex.response) {
      message =
        ex.response.data?.message ||
        ex.response.data?.result?.message ||
        message;

      const resultData = ex.response.data?.result;
      if (
        ex.response.status === 403 &&
        resultData &&
        resultData.code === KEYCLOAK_LOGIN_CODE_RESPONSE.RESET_PASSWORD
      ) {
        resetPasswordFn(resultData.accessToken);
        yield put(
          Actions.signInFailure('É necessário redefinir sua senha.', formRef)
        );
        return;
      }
    }

    yield put(Actions.signInFailure(message, formRef));
  }
}

function signInSuccess({ payload }) {
  const { history, from } = payload;

  history.push(from);
}

function signInFailure({ payload }) {
  const { message, formRef } = payload;

  if (formRef) {
    formRef.setErrors({ password: message });
  }
}

function signOut({ payload }) {
  const { history } = payload;

  history.push('/login');
  persistor.purge();
}

export default all([
  takeLatest(Types.SIGN_IN, signIn),
  takeLatest(Types.SIGN_IN_SUCCESS, signInSuccess),
  takeLatest(Types.SIGN_IN_FAILURE, signInFailure),
  takeLatest(Types.SIGN_OUT, signOut),
]);
